import React from 'react';
import { NavLink } from "react-router-dom";
import SupportOp from '../../../../components/Popup/PopupOpInfo/_component/SupportOp';
import S3Image from "../../../../components/S3Image";
import { selectOpDetail } from '../../../../util/store/selectors';
import { useSelector } from "../../../../util/store/store";
import { vesselTypes } from "../../../../util/varibles/constants";
import stylesContainer from '../../style.module.scss';
import styles from './style.module.scss';

const Vessel: React.FC = () => {
    const data = useSelector(selectOpDetail.data);
    if (!data.vessel) return null;

    const { id, name, type, image_url } = data.vessel;

    return <div className={stylesContainer.section}>
        <div className={[stylesContainer['header-box'], styles.header].join(' ')}>
            <NavLink to={'/vessel/' + id}>
                <span className="mr-1 truncate">{name}</span>
            </NavLink>
            <div className={styles['name-boat']}>{vesselTypes[type - 1].name}</div>
        </div>
        <div className='flex flex-col gap-4 sm:flex-row'>
            <div className="w-full max-w-full shrink-0 overflow-hidden rounded-[8px] sm:max-w-[36%]">
                <S3Image {...{ imageUrl: image_url || '', height: null }} />
            </div>
            <SupportOp op={data.operation} vesselName={data.vessel.name} />
        </div>
    </div>;
}

export default Vessel;
